
import React, { useEffect, useState } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { CreateUser } from '../../../services/auth-service/authService';
import {GetJobNames, GetKpiNames, GetProcessNames, GetfilterdJobNames, GetAllPages, GetAllentities, GetAlldivision, GetroleNames, GetroleName, SavePermissions} from '../../../services/process/process_data/process_data';

import axios from 'axios';
import Select , { components } from "react-select";


// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function SignUp() {
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
const [role1, setrole1] = useState({});
    const [formData, setFormData] = useState({
        name: '',
        lastname: '',
        employee_no: '',
        email: '',
        mobile_number: '',
        department: '',
        reporting_manager: '',
      });


//   const handleSubmit = (event) => {
//     event.preventDefault();
//     const data = new FormData(event.currentTarget);
//     console.log({
//       email: data.get('email'),
//       password: data.get('password'),
//     });
//   };


const [role, setrole] = useState({});

const handleRole = (event) =>{
  setrole(event);
  
}

  function handleSubmit(event) {
    event.preventDefault();
   
    let payload = {
      'name':formData.name,
      'lastname':formData.lastname,
      'employee_no':formData.employee_no,
      'email':formData.email,
      'username':formData.email,
      'mobile_number':formData.mobile_number,
      'department':formData.department,
      'reporting_manager':formData.reporting_manager,
      'role_id':role.value,
    
    };
    console.log('called');
    var getFileUploadsList = CreateUser();

    axios.post(getFileUploadsList[1],  payload, getFileUploadsList[0])
        .then(
            response => {
                console.log("added user data!!!", response);         
                
            }
        ).catch(
            error => {
                console.log("Error in store user data!!!", error);
        
            }
        );

}

  // Function to update the form data
  const handleFormChange = (event) => {
    const { name, value } = event.target;
    if (name == 'employee_no'){
        setFormData({
            ...formData,
            [name]: parseInt(value),
          });
    }else{
        setFormData({
            ...formData,
            [name]: value,
          });
    }
    
  };

  const fetchallrolenames = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }
  
    var FileUploadCredentials = GetroleNames();
  
    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response role!!!", response);
                let table_data = response.data;
  
                let names = [];
                let id = '';
                if (Array.isArray(table_data)){
                table_data?.map((data) => {
                    id = data.id;
                    let obj = {
                        value: data.id,
                        label: data.role_name
                    }
                    names.push(obj);
                })
                }
                setrole1(names);
            }
        )
  }
  
  useEffect(() => {
  
    fetchallrolenames();
  },[]);

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography> */}
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="given-name"
                  name="name"
                  required
                  fullWidth
                  id="name"
                  label="Name"
                  autoFocus
                  value={formData.name}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  id="lastname"
                  label="Last Name"
                  name="lastname"
                  autoComplete="Last-name"
                  value={formData.lastname}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  
                  name="employee_no"
                  required
                  fullWidth
                  type="number" 
                  id="employee_no"
                  label="EmpNo"
                  autoComplete="employee_no"
                  value={formData.employee_no}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  value={formData.email}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="mobile_number"
                  label="mobile_number"
                  type="mobile_number"
                  id="mobile_number"
                  autoComplete="new-mobileno"
                  value={formData.mobile_number}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12}>
        
                    <div className="form-group ">
                        
                        <Select
                            clearable
                            options={role1}
                            selection
                            size='mini'
                            value={role}
                            onChange={handleRole}
                        />
                    </div>
                
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="department"
                  label="department"
                  type="department"
                  id="department"
                  autoComplete="new-department"
                  value={formData.department}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="reporting_manager"
                  label="reporting_manager"
                  type="reporting_manager"
                  id="reporting_manager"
                  autoComplete="new-reporting_manager"
                  value={formData.reporting_manager}
                  onChange={handleFormChange}
                />
              </Grid>
              
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign Up
            </Button>
            {/* <Grid container justifyContent="flex-end">
              <Grid item>
                <Link href="#" variant="body2">
                  Already have an account? Sign in
                </Link>
              </Grid>
            </Grid> */}
          </Box>
        </Box>
        
      </Container>
    </ThemeProvider>
  );
}